const icon = require('vue-svgicon');
icon.register({
    'check-document': {
        width: 12,
        height: 12,
        viewBox: '0 0 12 12',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.333 11V3.334L7.666.666H2A.333.333 0 001.667 1v10c0 .184.149.333.333.333h8c.184 0 .333-.149.333-.333zM7.667 3.333V1.488l1.845 1.845H7.667zm2 .667H7V1.333H2.667a.333.333 0 00-.333.334v8.666c0 .184.149.333.333.333h6.666a.333.333 0 00.334-.333V4zM5.555 8.665l.443-.443-.037-.038 2.376-2.377-.477-.478-2.377 2.377L4.445 6.67l-.443.444L5.039 8.15l-.043.044.477.477.044-.043.038.037z" _fill="#27242D"/>`,
    },
});
